import { PropsWithChildren } from "react";
import cx from "classnames";

import { Dialog, IDialogProps } from "components";

import styles from "./NewDialog.module.scss";

export type NewDialogProps = PropsWithChildren<IDialogProps>;

export const NewDialog = ({
  className,
  children,
  ...props
}: NewDialogProps) => {
  return (
    <Dialog
      className={cx(styles.dialog, className)}
      wrapClassName={styles.wrap}
      {...props}
    >
      {children}
    </Dialog>
  );
};

export default NewDialog;
